document.addEventListener('turbo:load', function() {

})
